module.exports = __webpack_public_path__ + "static/media/website-05.2f4eb416.png";